import { ColumnDef } from '@tanstack/react-table';

export const columns: ColumnDef<Employee>[] = [
  {
    accessorKey: 'fullname',
    header: 'Employee',
  },
  {
    accessorKey: 'role',
    header: 'Role',
  },
  {
    accessorKey: 'collectedAmount',
    header: 'Collected Amount',
  },
];
